import { render, staticRenderFns } from "./myincome.vue?vue&type=template&id=5a5f990e&scoped=true&"
import script from "./myincome.vue?vue&type=script&lang=js&"
export * from "./myincome.vue?vue&type=script&lang=js&"
import style0 from "./myincome.vue?vue&type=style&index=0&id=5a5f990e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a5f990e",
  null
  
)

export default component.exports